var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "footer" },
    [
      _vm._t("bottom"),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _vm.clientId == 320684
          ? _c("div", { staticClass: "main" }, [
              _c("div", { staticClass: "service clear" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("dl", { staticClass: "service-2" }, [
                  _c("dt", [_vm._v("关于我们")]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://wwwvideo.jshmtv.com/web/program/about#jianjie"
                        }
                      },
                      [_vm._v("关于我们")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://wwwvideo.jshmtv.com/web/program/about#xinwen"
                        }
                      },
                      [_vm._v("新闻热线")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://wwwvideo.jshmtv.com/web/program/about#guanggao"
                        }
                      },
                      [_vm._v("广告服务")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ]),
              _vm._v(" "),
              _vm._m(3)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 320598
          ? _c("div", { staticClass: "main" }, [
              _c("div", { staticClass: "service clear" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("dl", { staticClass: "service-2" }, [
                  _c("dt", [_vm._v("关于我们")]),
                  _vm._v(" "),
                  _c("dd", [
                    _c("a", { attrs: { href: _vm.host + "/news/about" } }, [
                      _vm._v("关于我们")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      { attrs: { href: _vm.host + "/news/about#rexian" } },
                      [_vm._v("新闻热线")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      { attrs: { href: _vm.host + "/news/about#guanggao" } },
                      [_vm._v("广告服务")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _vm._m(6)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "copy" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("img", {
                  staticStyle: {
                    "vertical-align": "middle",
                    "margin-left": "10px",
                    height: "20px"
                  },
                  attrs: { src: "/public/w/img/pc/beianlogo.png" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "share clear" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bdsharebuttonbox bdshare-button-style0-32"
                    },
                    [
                      _c("a", {
                        staticClass: "top_btn",
                        staticStyle: { display: "inline-block" },
                        on: {
                          click: function($event) {
                            _vm.smoothscroll()
                          }
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(8)
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 410600
          ? _c("div", { staticClass: "footer-tag-list main center" }, [
              _c("div", { staticClass: "service  clear" }, [
                _c("div", [
                  _c("a", { attrs: { href: _vm.host + "/news/about" } }, [
                    _vm._v("关于我们")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.henanjubao.com/",
                        target: "_black"
                      }
                    },
                    [_vm._v("河南省互联网违法和不良信息举报中心")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: { href: "http://www.12377.cn", target: "_black" }
                    },
                    [_vm._v("中国互联网违法和不良信息举报中心入口")]
                  ),
                  _vm._v(" "),
                  _c("a", [_vm._v("举报电话:0392-3331766")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41061102000115",
                        target: "_black"
                      }
                    },
                    [_vm._v("豫公网安备 41061102000115号")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "copy" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "share clear" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bdsharebuttonbox bdshare-button-style0-32"
                    },
                    [
                      _c("a", {
                        staticClass: "top_btn",
                        staticStyle: { display: "inline-block" },
                        on: {
                          click: function($event) {
                            _vm.smoothscroll()
                          }
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 321300
          ? _c("div", { staticClass: "footer-tag-list main center" }, [
              _vm._m(10),
              _vm._v(" "),
              _vm._m(11)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 320100
          ? _c("div", { staticClass: "main" }, [
              _c("div", { staticClass: "service clear" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("dl", { staticClass: "service-2" }, [
                  _c("dt", [_vm._v("关于我们")]),
                  _vm._v(" "),
                  _c("dd", [
                    _c("a", { attrs: { href: _vm.host + "/news/about" } }, [
                      _vm._v("关于我们")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      { attrs: { href: _vm.host + "/news/about#rexian" } },
                      [_vm._v("新闻热线")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      { attrs: { href: _vm.host + "/news/about#guanggao" } },
                      [_vm._v("广告服务")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "copy" }, [
                  _c("p", [_vm._v("版权所有 © 南京晨报社")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "share clear" }, [
                    _c(
                      "div",
                      {
                        staticClass: "bdsharebuttonbox bdshare-button-style0-32"
                      },
                      [
                        _c("a", {
                          staticClass: "top_btn",
                          staticStyle: { display: "inline-block" },
                          on: {
                            click: function($event) {
                              _vm.smoothscroll()
                            }
                          }
                        })
                      ]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 410900
          ? _c("div", { staticClass: "footer-tag-list main center" }, [
              _vm._m(14),
              _vm._v(" "),
              _vm._m(15),
              _vm._v(" "),
              _vm._m(16),
              _vm._v(" "),
              _vm._m(17)
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-1" }, [
      _c("dt", [_vm._v("产品和服务")]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "http://www.jshmzc.com/", target: "_black" } },
          [_vm._v("海门之窗")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("东洲城事")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { left: "50px", top: "125px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320684/dzcs.png" } }),
            _vm._v(" "),
            _c("p", [_vm._v("iphone & Android")]),
            _vm._v(" "),
            _c("span", [_vm._v("微信扫一扫 东洲城事")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticStyle: { left: "50px", top: "130px" } }, [
        _c(
          "a",
          { attrs: { href: "http://gdt.haimen.gov.cn/", target: "_black" } },
          [_vm._v("海门市广播电视台")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("广电之星")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { left: "50px", top: "170px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320684/gdzx.jpg" } }),
            _vm._v(" "),
            _c("p", [_vm._v("iphone & Android")]),
            _vm._v(" "),
            _c("span", [_vm._v("微信扫一扫 广电之星")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("海门日报")]),
        _vm._v(" "),
        _c("div", { staticClass: "qrcode", staticStyle: { top: "210px" } }, [
          _c("img", { attrs: { src: "/public/w/img/320684/hmrb.jpg" } }),
          _vm._v(" "),
          _c("p", [_vm._v("iphone & Android")]),
          _vm._v(" "),
          _c("span", [_vm._v("微信扫一扫 海门日报")]),
          _vm._v(" "),
          _c("i", [
            _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("FM100.6")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { left: "50px", top: "210px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320684/fm1006.jpg" } }),
            _vm._v(" "),
            _c("p", [_vm._v("iphone & Android")]),
            _vm._v(" "),
            _c("span", [_vm._v("微信扫一扫 FM100.6海门广播")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd"),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("海门电视台教育频道")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { left: "50px", top: "255px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320684/edu.png" } }),
            _vm._v(" "),
            _c("p", [_vm._v("iphone & Android")]),
            _vm._v(" "),
            _c("span", [_vm._v("微信扫一扫 海门电视台教育频道")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-3" }, [
      _c("dt", [_vm._v("免责声明")]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。"
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v("如您因版权等问题需要与本网联络，请在30日内联系我们。")
      ]),
      _vm._v(" "),
      _c("dd", [_vm._v("本网站法律顾问：江苏剑桥人律师事务所严文戟律师")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-4" }, [
      _c("dt", [_vm._v("APP下载")]),
      _vm._v(" "),
      _c("dd", [
        _c("img", { attrs: { src: "/public/w/img/320684/download.jpg" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy" }, [
      _c("p", [
        _vm._v("版权所有 © 海门电视台 2018 "),
        _c(
          "a",
          {
            staticStyle: {
              color: "#ffffff",
              display: "inline-block",
              "text-decoration": "none",
              height: "20px",
              "line-height": "20px"
            },
            attrs: { target: "blank", href: "http://www.beian.miit.gov.cn" }
          },
          [_vm._v("苏ICP备17033365号")]
        ),
        _vm._v(" 苏新网备2008040号 "),
        _c(
          "a",
          {
            staticStyle: {
              color: "#ffffff",
              display: "inline-block",
              "text-decoration": "none",
              height: "20px",
              "line-height": "20px"
            },
            attrs: {
              target: "_blank",
              href:
                "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32068402000163"
            }
          },
          [_vm._v("苏公网安备 32068402000163号")]
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticStyle: {
          "vertical-align": "middle",
          "margin-left": "10px",
          height: "20px"
        },
        attrs: { src: "/public/w/img/pc/beianlogo.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-1" }, [
      _c("dt", [_vm._v("产品和服务")]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "https://www.wjdaily.com/", target: "_black" } },
          [_vm._v("吴江新闻网")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          {
            attrs: {
              href: "http://bbs.wjdaily.com/bbs/portal.php",
              target: "_black"
            }
          },
          [_vm._v("东太湖论坛")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("今吴江客户端")]),
        _vm._v(" "),
        _c("div", { staticClass: "qrcode", staticStyle: { top: "170px" } }, [
          _c("img", { attrs: { src: "/public/w/img/320598/ewm.png" } }),
          _vm._v(" "),
          _c("p", [_vm._v("iphone & Android")]),
          _vm._v(" "),
          _c("span", [_vm._v("扫一扫下载今吴江APP")]),
          _vm._v(" "),
          _c("i", [
            _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "http://epaper.ljwj150.com", target: "_black" } },
          [_vm._v("吴江日报数字报")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "http://weibo.com/lejuwj", target: "_black" } },
          [_vm._v("苏州吴江发布微博")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("融媒吴江")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { top: "215px", left: "29px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320598/wjrb.jpg" } }),
            _vm._v(" "),
            _c("span", [_vm._v("扫一扫关注融媒吴江")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-3" }, [
      _c("dt", [_vm._v("免责声明")]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。"
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v("如您因版权等问题需要与本网联络，请在30日内联系我们。")
      ]),
      _vm._v(" "),
      _c("dd", [_vm._v("本网站法律顾问：江苏剑桥人律师事务所严文戟律师")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-4" }, [
      _c("dt", [_vm._v("APP下载")]),
      _vm._v(" "),
      _c("dd", [_c("img", { attrs: { src: "/public/w/img/320598/ewm.png" } })]),
      _vm._v(" "),
      _c("dd", [_vm._v("今吴江")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("版权所有 © 吴江融媒体中心 2019 "),
      _c(
        "a",
        {
          staticStyle: {
            color: "#ffffff",
            display: "inline-block",
            "text-decoration": "none",
            height: "20px",
            "line-height": "20px"
          },
          attrs: { target: "blank", href: "http://www.beian.miit.gov.cn" }
        },
        [_vm._v("苏ICP备10217754号")]
      ),
      _vm._v(" 苏新网备2008040号 "),
      _c(
        "a",
        {
          staticStyle: {
            color: "#ffffff",
            display: "inline-block",
            "text-decoration": "none",
            height: "20px",
            "line-height": "20px"
          },
          attrs: {
            target: "_blank",
            href:
              "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050902100461 &#10;&#10;"
          }
        },
        [_vm._v("苏公网安备 32050902100461号")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "map" }, [
      _c("div", { staticClass: "tel" }, [
        _c("div", { staticClass: "tel1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tel2" }, [
          _c("a", { attrs: { href: "http://www.12377.cn/", target: "_blank" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tel3" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fri-link" }, [
        _c("div", { staticClass: "link1" }, [
          _c("a", {
            attrs: {
              href:
                "http://bszs.conac.cn/sitename?method=show&id=540510F517164DF6E053022819AC95AE",
              target: "_blank"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "link2" }, [
          _c("a", {
            attrs: {
              href: "http://61.155.26.218/license?id=9207",
              target: "_blank"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "link3" }),
        _vm._v(" "),
        _c("div", { staticClass: "link4" }, [
          _c("a", { attrs: { href: "http://www.12315.cn/", target: "_blank" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "link5" }, [
          _c("a", {
            attrs: {
              href: "http://61.155.26.218/license/credit?id=9207",
              target: "_blank"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "link6" }, [
          _c("a", {
            attrs: {
              href: "http://61.155.26.218/license/credit?id=9207",
              target: "_blank"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("版权所有 © 鹤壁市广播电视台\n            "),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://bszs.conac.cn/sitename?method=show&id=0EC7E26666AF726AE053022819AC80CC",
            target: "_black"
          }
        },
        [
          _c("img", {
            attrs: { src: "http://dcs.conac.cn/image/blue.png", alt: "" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://beian.miit.gov.cn/#/Integrated/index",
            target: "_black"
          }
        },
        [
          _vm._v(
            "\n              2018 豫ICP备05017900号-1 | 互联网视听节目服务 ( AVSP ): 豫网备 2016002 号\n              "
          )
        ]
      ),
      _vm._v(" "),
      _c("a", { attrs: { href: "javascript:;" } }, [
        _vm._v("互联网新闻许可证: 41120180010")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticStyle: {
            "text-decoration": "none",
            width: "200px",
            "line-height": "106px",
            display: "block",
            margin: "auto"
          },
          attrs: {
            id: "_xinchacharenzheng_cert_vip_kexinweb",
            target: "_blank",
            href: "https://myssl.com/seal/detail?domain=www.hebitv.com"
          }
        },
        [
          _c("img", {
            staticStyle: { height: "106px", width: "200px" },
            attrs: {
              src:
                "https://sealres.myssl.com/seal/img/2x/seal.png?domain=www.hebitv.com"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://www.12377.cn", target: "_blank" } },
      [
        _c("img", {
          staticStyle: {
            width: "1010px",
            height: "65px",
            display: "block",
            margin: "20px auto 0"
          },
          attrs: { src: "/public/w/img/321300/jubao.png" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom bottomsq" }, [
      _c("div", { staticClass: "fo_con" }, [
        _c("div", { staticClass: "fo1" }, [_vm._v("Copyright © 2018")]),
        _vm._v(" "),
        _c("div", { staticClass: "fo2" }, [
          _vm._v("中共宿迁市委宣传部\n              "),
          _c("br"),
          _vm._v("宿迁报业网络传媒有限公司")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "fo3", staticStyle: { "line-height": "19px" } },
          [
            _c(
              "a",
              {
                staticStyle: {
                  display: "block",
                  "margin-top": "20px",
                  "font-size": "12px"
                },
                attrs: { href: "https://beian.miit.gov.cn/" }
              },
              [_vm._v("备案号：苏ICP备10105892号-14")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticStyle: { display: "block", "font-size": "12px" },
                attrs: { href: "javascript:;" }
              },
              [_vm._v("互联网新闻许可：32120180020")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "fo4" }, [
          _vm._v(" 违法信息举报电话：0527-84389919\n              "),
          _c("br"),
          _vm._v(
            "违法信息举报邮箱：suxinwen2015@126.com              \n            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fo5" }, [
          _vm._v("Powered by\n              "),
          _c("a", { attrs: { href: "#" } }, [_vm._v("速新闻")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-1" }, [
      _c("dt", [_vm._v("产品和服务")]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("爱南京客户端")]),
        _vm._v(" "),
        _c("div", { staticClass: "qrcode", staticStyle: { top: "120px" } }, [
          _c("img", { attrs: { src: "/public/w/img/320100/ewm.png" } }),
          _vm._v(" "),
          _c("p", [_vm._v("iphone & Android")]),
          _vm._v(" "),
          _c("span", [_vm._v("扫一扫下载爱南京APP")]),
          _vm._v(" "),
          _c("i", [
            _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("南京晨报小记者")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { top: "120px", left: "50px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320100/xiaojizhe.png" } }),
            _vm._v(" "),
            _c("span", [_vm._v("扫一扫关注小记者")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("南京晨报微信")]),
        _vm._v(" "),
        _c("div", { staticClass: "qrcode", staticStyle: { top: "165px" } }, [
          _c("img", { attrs: { src: "/public/w/img/320100/weixin.png" } }),
          _vm._v(" "),
          _c("span", [_vm._v("扫一扫关注南京晨报")]),
          _vm._v(" "),
          _c("i", [
            _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("南京晨报乔医生")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { top: "165px", left: "50px" }
          },
          [
            _c("img", {
              attrs: { src: "/public/w/img/320100/doctorqiao.png" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("扫一扫关注乔医生")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "https://www.inanjin.com/", target: "_black" } },
          [_vm._v("南京晨报网")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "http://njcb.jschina.com.cn", target: "_black" } },
          [_vm._v("南京晨报数字报")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          {
            attrs: {
              href: "https://weibo.com/nanjingchenbao?topnav=1&topsug=1",
              target: "_black"
            }
          },
          [_vm._v("南京晨报微博")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-3" }, [
      _c("dt", [_vm._v("免责声明")]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。"
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v("如您因版权等问题需要与本网联络，请在30日内联系我们。")
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "任何媒体不得擅自转载本网站由其他单位提供的信息和服务内容，如需转载，必须与本网站联系获得合法授权。"
        )
      ]),
      _vm._v(" "),
      _c("dd", [_vm._v("举报电话：025-58682396")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service  clear" }, [
      _c("div", [
        _c("a", { attrs: { href: "http://www.12377.cn", target: "_black" } }, [
          _vm._v("中国互联网违法和不良信息举报中心入口")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://www.henanjubao.com/", target: "_black" } },
          [_vm._v("河南省互联网违法和不良信息举报中心")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.pyxww.com/pyshlwjbzx/",
              target: "_black"
            }
          },
          [_vm._v("濮阳市互联网违法和不良信息举报中心")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "service  clear", staticStyle: { "padding-top": "0" } },
      [
        _c(
          "a",
          { staticStyle: { cursor: "auto" }, attrs: { href: "javascript:;" } },
          [_vm._v("违法和不良信息举报电话：0393-4690809")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticStyle: { cursor: "auto" }, attrs: { href: "javascript:;" } },
          [_vm._v("涉未成年人举报电话：0393-4690809")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticStyle: { cursor: "auto" }, attrs: { href: "javascript:;" } },
          [_vm._v("举报邮箱:pytvxmt@qq.com")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "service  clear", staticStyle: { "padding-top": "0" } },
      [
        _c(
          "a",
          {
            staticStyle: { "text-decoration": "none" },
            attrs: {
              id: "_xinchacharenzheng_cert_vip_ssl",
              target: "_blank",
              href:
                "https://xyt.xinchacha.com/getpcInfo?sn=1400380390676688896&certType=8"
            }
          },
          [
            _c("img", {
              staticStyle: { height: "50px", width: "164px" },
              attrs: { src: "https://xyt.xinchacha.com/img/icon/icon8.png" }
            })
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy" }, [
      _c("p", [
        _vm._v("版权所有 © 濮阳市广播电视台\n            "),
        _c(
          "a",
          {
            attrs: {
              href: "https://beian.miit.gov.cn/#/Integrated/index",
              target: "_black"
            }
          },
          [_vm._v("\n              豫ICP备20018960号-1\n            ")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3788cc60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3788cc60","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-layout/footer/footer.vue
// module id = null
// module chunks = 